<template>
  <svg class="xds:icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.53734 1.86268C6.39074 1.71601 6.21667 1.59965 6.02508 1.52027C5.8335 1.44088 5.62815 1.40002 5.42076 1.40002C5.21338 1.40002 5.00803 1.44088 4.81645 1.52027C4.62486 1.59965 4.45079 1.71601 4.30418 1.86268L3.99992 2.16694L3.69566 1.86268C3.39953 1.56655 2.99788 1.40018 2.57908 1.40018C2.16028 1.40018 1.75864 1.56655 1.4625 1.86268C1.16637 2.15882 1 2.56046 1 2.97926C1 3.39806 1.16637 3.7997 1.4625 4.09584L3.99992 6.63326L6.53734 4.09584C6.68402 3.94923 6.80037 3.77516 6.87976 3.58358C6.95914 3.39199 7 3.18664 7 2.97926C7 2.77188 6.95914 2.56653 6.87976 2.37494C6.80037 2.18336 6.68402 2.00929 6.53734 1.86268Z"
      stroke="currentColor"
      stroke-width="0.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
